var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14.899,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#264D6D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.731 6.733-2.424-2.425V1.507a.917.917 0 0 0-1.835 0v.967L9.667.668c-.893-.892-2.445-.89-3.335.002L.268 6.733A.918.918 0 0 0 1.566 8.03l6.062-6.063a.541.541 0 0 1 .742 0l6.064 6.063a.915.915 0 0 0 1.297 0 .917.917 0 0 0 0-1.297Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.319 3.707a.45.45 0 0 0-.637 0L2.348 9.04a.451.451 0 0 0-.132.319v3.889c0 .912.74 1.652 1.653 1.652h2.64v-4.09H9.49v4.09h2.64c.913 0 1.653-.74 1.653-1.652v-3.89a.45.45 0 0 0-.132-.318L8.319 3.707Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.59d70ac8.svg";
export { ForwardRef as ReactComponent };